import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { FireAnalyticsService } from "@service/fire-analytics.service";

@Component({
    selector:'app-mf-creation',
    templateUrl:'./mf-creation.component.html',
    styleUrls:[]
})
export class MfCreationComponent {
    constructor( 
        private dialogRef: MatDialogRef<MfCreationComponent>,
        private router:Router,
        private analytics: FireAnalyticsService
    ){}

    gotoMutualfundProfile(){
        this.analytics.logEvents('Go To BSE Account Creation')
        let uservertical = window.localStorage.getItem('userVertical')
        this.router.navigate([`/${uservertical}/bse-account`]);
        this.close(true);
    }

    close(isUpdate){
        this.dialogRef.close(isUpdate)

    }
}